import React from 'react'
// import { Link } from 'react-router-dom';
// import Footer from '../../../Layout/Footer';
// import Header from '../../../Layout/Header';
import feedback from '../../../../assets/img/notify.jpg';
// import { Button, Form } from 'react-bootstrap';

const mystyle = {
    backgroundColor: "transparent",
};
const ChatsOnline = () => {
    return (
        <React.Fragment>
            {/* <Header /> */}
            {/* <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Chats </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Chats</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="msger">
            </section> */}
            <section class="msger">
                <div className='container'>
                    <div className='row  h-100'>
                        <div className='col-lg-12'>
                            <header className="msger-header">
                                <div className="msger-header-title">
                                    <div className="btn-outline-secondary d-flex border-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src={feedback} className='img-fluid' alt='' />
                                    </div>
                                    <div>
                                        <h5>Firoz</h5>
                                        <span className='status'>Online</span>
                                    </div>
                                </div>

                                <div className="msger-header-options">
                                    <span><i className="fas fa-cog"></i></span>
                                </div>
                            </header>

                            <main className="msger-chat">
                                <div className="msg left-msg">

                                    <div className="msg-bubble">
                                        <div className="msg-info">
                                            <div className="msg-info-name">BOT</div>
                                            <div className="msg-info-time">12:45</div>
                                        </div>

                                        <div className="msg-text">
                                            Hi, welcome to SimpleChat! Go ahead and send me a message. 😄
                                        </div>
                                    </div>
                                </div>

                                <div className="msg right-msg">

                                    <div className="msg-bubble">
                                        <div className="msg-info">
                                            <div className="msg-info-name">Sajad</div>
                                            <div className="msg-info-time">12:46</div>
                                        </div>

                                        <div className="msg-text">
                                            You can change your name in JS section!
                                        </div>
                                    </div>
                                </div>
                            </main>
                            {/* <Form className="msger-inputarea">
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="text" className="msger-input w-100" placeholder="Enter your message..." />
                                </Form.Group>
                                <Button><i className="bi bi-paperclip"></i></Button>
                                <Button type="submit" className="msger-send-btn">
                                    Send
                                </Button>
                            </Form> */}
                            <form className="msger-inputarea">
                                <input type="text" class="msger-input" placeholder="Enter your message..." />
                                <div className="dropdown dropup p-0">
                                    <button className="" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-paperclip"></i>
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" style={mystyle}>
                                        <li>
                                            <a className="dropdown-item" href="#">
                                                <div className='file'>
                                                    <label for='input-file'>
                                                        <i className="bi bi-images" style={{ color: "#fff" }}></i>
                                                    </label>
                                                    <input id='input-file' type='file' />
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="#">
                                                <div className='file'>
                                                    <label for='input-file'>
                                                        <i className="bi bi-files" style={{ color: "#fff" }}></i>
                                                    </label>
                                                    <input id='input-file' type='file' />
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="#">
                                                <div className='file'>
                                                    <label for='input-file'>
                                                        <i className="bi bi-camera-video" style={{ color: "#fff" }}></i>
                                                    </label>
                                                    <input id='input-file' type='file' />
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <button type="submit" className="msger-send-btn" >Send</button>
                            </form>
                            {/* <div class="variants">
                                <div class='file'>
                                    <label for='input-file'>
                                        <i class="bi bi-images"></i>
                                    </label>
                                    <input id='input-file' type='file' />
                                </div>
                                <div class='file'>
                                    <label for='input-file'>
                                        <i class="bi bi-files"></i>
                                    </label>
                                    <input id='input-file' type='file' />
                                </div>
                                <div class='file'>
                                    <label for='input-file'>
                                        <i class="bi bi-camera-video"></i>
                                    </label>
                                    <input id='input-file' type='file' />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* <Footer /> */}
        </React.Fragment>
    )
}

export default ChatsOnline;